import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { LocalService } from '../local.service';
import { ToastrService } from 'ngx-toastr';
import {navmenuservices} from '../nav-menu/nav-menu.services';
//import {navmenu} from '../nav-menu/nav-menu.component';
//import jwt from 'jsonwebtoken';


@Component({
  selector: 'app-prehomepage',
  templateUrl: './prehomepage.component.html',
  styleUrls: ['./prehomepage.component.css'],
  providers: [navmenuservices]
})
export class PrehomepageComponent implements OnInit {
  public apitoken = this.localService.getJsonValue('apitoken');
  isautologteam=+this.localService.getJsonValue('isautologteam');
  userid=this.localService.getJsonValue('userid');
  autologUrl:string=environment.autologUrl;
  autologUserTeamId:number=environment.autologUserTeamId;
  public list;
  constructor(  private route: ActivatedRoute,private localService: LocalService,
    private navmenuservice: navmenuservices,
    private router: Router,   private toastr: ToastrService) { }

  ngOnInit() {
  }
  openAcrn(){
 //   localStorage.removeItem("navmenu");
 //   this.localService.setJsonValue('navmenu', true);
 
 if(this.isautologteam!=this.autologUserTeamId){
  this.router.navigate(['/home']);
 }else{

  this.navmenuservice.postdata(this.userid).subscribe((res) => {
    
    if (res != undefined) {
      this.list = res;
      console.log(this.list);
      localStorage.setItem('UserManagement_action', this.list[0]['actionrights']);
      this.router.navigate(['/home/usermgt/user']);
    }
  }, error => { this.toastr.error(error.error) });
 
 }
   
  }
  openAutolog(){
    
    let openAutologUrl='';  
     openAutologUrl=this.autologUrl+this.apitoken+'&auth=acrn';   
   //  localStorage.clear();
     // Clear the localStorage
   //  this.localService.clearToken();
    window.open(openAutologUrl);
  }
}
